import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';
import {
  fetchAreaInformationField,
  AreaInformationFieldType,
} from './useAreaDates';

interface MapstatBoundsType {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
}

interface MapstatQueryType {
  fieldName: string;
  categoryId: string;
  validAt: string;
  bounds: MapstatBoundsType;
}

interface MapstatFeaturePropertiesType {
  field_value: number;
  field_unit: string;
  area_display_name: string;
  field_display_name: string;
}

interface MapstatGeoJsonType {
  type: string;
  features: {
    type: string;
    geometry: { type: string; coordinates: unknown };
    properties: MapstatFeaturePropertiesType;
  }[];
}

interface MapstatResultType {
  field: AreaInformationFieldType;
  geojson: MapstatGeoJsonType;
}

const useMapstatSearch = () => {
  return useMutation({
    mutationFn: async (
      query: MapstatQueryType
    ): Promise<MapstatResultType | null> => {
      const field = await fetchAreaInformationField(query.fieldName);
      if (!field) return null;

      const params = new URLSearchParams({
        category_ids: String(query.categoryId),
        information_field_id: String(field.id),
        min_wgs84lat: String(query.bounds.minLat),
        max_wgs84lat: String(query.bounds.maxLat),
        min_wgs84lon: String(query.bounds.minLng),
        max_wgs84lon: String(query.bounds.maxLng),
        valid_at: query.validAt,
      });

      const URL = `${import.meta.env.VITE_API_AREA_POLYGON_URL}?${params.toString()}`;
      const { data } = await axiosClient.get<MapstatGeoJsonType>(URL);

      return { field, geojson: data };
    },
  });
};

export default useMapstatSearch;
export type {
  MapstatBoundsType,
  MapstatGeoJsonType,
  MapstatResultType,
  MapstatFeaturePropertiesType,
};
